import React, { Component } from 'react';
import { input } from "antd";
import './DocumentList.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import 'react-datetime/css/react-datetime.css';

const { TextArea } = input;

class DocumentInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: false,
            mode: this.props.mode,
        };

        this.handleRead = this.handleRead.bind(this);
    }

    handleRead(item) {
        this.props.handleInfo(item);
        this.props.toggle();
    }

    render() {
        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                }
                <div className="memberForm-container">
                    <div className="FormRenk col-sm-12 text-center ">
                        {this.props.documentShipped.map((item, i) => {
                            if (item.read === false) {
                                return (
                                    <h3 key={i}><a onClick={() => this.handleRead(item)}>Yeni {item.evrakKonu} adlı evrak mevcut</a></h3>
                                );
                            }
                            return null;
                        })}
                    </div>
                    <div className="save-button-container">
                        <button onClick={this.props.toggle} className="member-save-button">
                            TAMAM
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentInfo;



// WEBPACK FOOTER //
// ./src/page/documentList/DocumentInfo.js